import { Interview } from 'utility/interfaces';

export const interviews: Interview[] = [
    {
        title: 'Nothing But Knives Feature',
        link: 'https://www.nothingbutknives.com/news/a-talk-with-the-geek-behind-knifegeek/',
        image: 'https://firebasestorage.googleapis.com/v0/b/bladesy-d4d55.appspot.com/o/nbk-logo-small-white.webp?alt=media&token=3662cf59-6066-430b-b3f8-26ab5611bc67',
        bg: 'black',
    },
    {
        title: 'Acquire.com Podcast Feature',
        link: 'https://blog.acquire.com/startup-acquisition-episode-92/',
        image: 'https://firebasestorage.googleapis.com/v0/b/proposaly-a45f6.appspot.com/o/acquire-com-3df55f10.png?alt=media&token=88dcccdf-fea7-4036-93bc-0f4fd8d7751a',
    },
    {
        title: 'Founders Club Feature',
        link: 'https://www.founderclub.com/stock-alarm/',
        image: 'https://pbs.twimg.com/profile_images/1643702307471732739/wpii-BL9_400x400.jpg',
    },
    {
        title: 'Indie Hackers Podcast Feature',
        link: 'https://podcasts.apple.com/us/podcast/268-trading-stocks-quitting-amazon-and-making-$20k/id1206165808?i=1000599750530',
        image: 'https://amfblog.s3.amazonaws.com/wp-content/uploads/2016/11/13183129/Screen-shot-2016-11-13-at-7.28.51-PM.png',
    },
    {
        title: 'Daily Free Press BU Feature',
        link: 'https://dailyfreepress.com/2020/02/13/bu-senior-codes-designs-and-advertises-to-alert-traders-as-vp-of-growth-of-stock-alarm-app/',
        image: 'https://pbs.twimg.com/profile_images/1263237003556073472/Scb-x48s.jpg',
    },
];
